import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import axios from "axios";

import { API } from "./lib/api";

// Cihaz kaydı axios ile gider: App.js interceptor'ı oturum token'ını (Authorization)
// ekler ve süresi dolmuşsa yeniler. Önceden çıplak fetch kullanılıyordu → uç 2026-04-15'te
// giriş zorunlu olunca Android kayıtları 401 alıyordu. Backend cihazı oturumdaki
// kullanıcıya bağlar; gövdedeki user_id artık yok sayılır (geriye uyum için gönderiliyor).
const registerToken = (token, userId, userType, platform) =>
  axios.post(`${API}/notifications/register-token`, {
    token, user_type: userType, user_id: userId, platform,
  });

// Platform kontrolü
export const isNativePlatform = () => {
  return Capacitor.isNativePlatform();
};

// Android için native push notification kurulumu
export const initializePushNotifications = async (userId, userType) => {
  if (!isNativePlatform()) {
    console.log('Push notifications: Web platform, using Firebase Web SDK');
    return null;
  }

  try {
    // İzin kontrolü
    let permStatus = await PushNotifications.checkPermissions();
    console.log('Push permission status:', permStatus);

    if (permStatus.receive === 'prompt') {
      // İzin iste
      permStatus = await PushNotifications.requestPermissions();
      console.log('Push permission after request:', permStatus);
    }

    if (permStatus.receive !== 'granted') {
      console.log('Push notifications permission denied');
      return null;
    }

    // Push notifications'ı kaydet
    await PushNotifications.register();
    console.log('Push notifications registered');

    // Token alındığında
    PushNotifications.addListener('registration', async (token) => {
      console.log('Push registration token:', token.value);
      
      // Token'ı backend'e gönder
      try {
        await registerToken(token.value, userId, userType, 'android');
        console.log('FCM token registered to backend');
      } catch (error) {
        console.error('Error registering token to backend:', error);
      }
    });

    // Kayıt hatası
    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push registration error:', error);
    });

    // Bildirim alındığında (uygulama açıkken)
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('Push notification received:', notification);
      // Burada toast gösterebilirsiniz
    });

    // Bildirime tıklandığında
    PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
      console.log('Push notification action performed:', notification);
      // Burada ilgili sayfaya yönlendirme yapabilirsiniz
    });

    return true;
  } catch (error) {
    console.error('Push notification initialization error:', error);
    return null;
  }
};

// Yerel uygulama: izin ZATEN verilmişse kaydı sessizce tazele (izin sormaz). Dinleyici bir kez eklenir;
// gelen token o anki panel türüyle (en son çağrının userType'ı) oturum kullanıcısına bağlanır.
let _silentType = null;
let _silentListener = false;
export const refreshNativeRegistration = async (userType) => {
  if (!isNativePlatform()) return false;
  try {
    const perm = await PushNotifications.checkPermissions();
    if (perm.receive !== 'granted') return false;
    _silentType = userType;
    if (!_silentListener) {
      _silentListener = true;
      PushNotifications.addListener('registration', (token) => {
        registerToken(token.value, null, _silentType, 'android').catch(() => {});
      });
    }
    await PushNotifications.register();
    return true;
  } catch {
    return false;
  }
};

// Token'ı backend'e kaydet (web için de kullanılabilir)
export const registerTokenToBackend = async (token, userId, userType, platform = 'web') => {
  try {
    await registerToken(token, userId, userType, platform);
    return true;
  } catch (error) {
    console.error('Error registering token:', error);
    return false;
  }
};
